import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useField } from 'remix-validated-form';

type Option = {
  value: string | number;
  label: string | number;
};

type SelectInputProps = {
  label: string;
  name: string;
  value?: string | number;
  defaultValue?: string | number;
  extraClasses?: string;
  options: Option[];
  optional?: boolean;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  showErrorText?: boolean;
};

const ValidatedSelectInput = ({
  label,
  name,
  value,
  extraClasses = '',
  options,
  optional = false,
  disabled = false,
  onChange,
  showErrorText = false,
}: SelectInputProps) => {
  const { t } = useTranslation();
  const { error, getInputProps } = useField(name);

  const idPrefix = useId();

  return (
    <div className={`form-floating ${extraClasses}`}>
      <select
        {...getInputProps({
          id: `${idPrefix}-${name}`,
          disabled: disabled,
          className: `form-select ${error ? 'is-invalid' : ''}`,
          onChange: onChange,
          value: value,
        })}
      >
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
      <label htmlFor={`${idPrefix}-${name}`}>
        {label}
        {optional && <span className="color-grey-500 -regular"> {t('global.forms.optional')}</span>}
      </label>
      {showErrorText && !!error && <div className="text-2 -regular color-error-600 mt-1">{t(error)}</div>}
    </div>
  );
};

export default ValidatedSelectInput;
